import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {API_BASE_URL} from '../constants'
import {setSessionPhone} from '../storage'
import axios from 'axios'
import {NavbarBrand, CenterTitle} from './header'
class Signup extends Component {


  constructor(props) {
    super(props)
    this.signup = this.signup.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {username:'', password:'', formWorking:false}
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  signup(e) {
    this.setState({formWorking:true})
    this.setState({error_response_data: undefined})
    e.preventDefault()
    axios({
      baseURL: API_BASE_URL,
      url:"/signup/",
      method:"POST",
      data: {username:this.state.username, password:this.state.password}
    }).then((response)=>{
      this.setState({formWorking:false})
      setSessionPhone(this.state.username)
      this.props.history.push("/verify_phone/")

    }).catch(err=>{
      this.setState({formWorking:false})
      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let username_error, password_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      if(typeof errors.username !== "undefined" && errors.username.length > 0) {
        username_error = errors.username[0]
      }
      if(typeof errors.password !== "undefined" && errors.password.length > 0) {
        password_error = errors.password[0]
      }
    }
    let submitBtn
    if(this.state.formWorking) {
      submitBtn = <input type="submit" className="btn btn-primary btn-block" value="Submitting..." disabled />
    }
    else {
      submitBtn = <input type="submit" className="btn btn-primary btn-block" value="Submit" />
    }



    return (
      <div>

        <section>
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-sm-offset-3">
                  <div className="">
                        <CenterTitle />
                        <h1 className="text-center">Signup</h1>
                        <form onSubmit={this.signup}>
                          <div className="form-group">
                            <label htmlFor="username">Phone</label>
                            <div className="input-group">
                              <div className="input-group-addon">+91</div>
                              <input type="text" name="username" className="form-control " onChange={this.handleInputChange} value={this.state.username} />
                            </div>
                            <span className="text-danger">{username_error}</span>
                          </div>

                          <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input type="password" name="password" className="form-control" onChange={this.handleInputChange} value={this.state.password} />
                            <span className="text-danger">{password_error}</span>
                          </div>


                          <div className="form-group">
                            {submitBtn}
                          </div>

                        </form>
                        Already registered, please <Link to="/login">Login</Link>

                  </div>
                </div>
              </div>
          </div>

        </section>
      </div>
    )
  }
}

export default Signup



// WEBPACK FOOTER //
// ./src/components/signup.js